import { render } from "./PayModeEdit.vue?vue&type=template&id=23519d30"
import script from "./PayModeEdit.vue?vue&type=script&lang=js"
export * from "./PayModeEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__